import type { QueryClient } from '@tanstack/react-query';

/**
 * Query prefixes a booking's money touches. Sending to the cashier, taking it
 * off the Till, cancelling and billing all change what these lists show: the
 * booking itself, its money card, the bookings list, the Till's queue, the
 * available-bike picker, the unit page, the Till's unpaid invoices, and the
 * customer page (whose tabs key on these same list prefixes, plus `customer`).
 * Prefixes, not imports: features never import each other (CLAUDE.md §4).
 */
const PREFIXES = [
  'bookings',
  'bookings-to-receive',
  'units',
  'unit',
  'invoices',
  'customer',
] as const;

export function invalidateAfterBookingMoney(queryClient: QueryClient, bookingUid: string): void {
  void queryClient.invalidateQueries({ queryKey: ['booking', bookingUid] });
  void queryClient.invalidateQueries({ queryKey: ['booking-money', bookingUid] });
  for (const prefix of PREFIXES) {
    void queryClient.invalidateQueries({ queryKey: [prefix] });
  }
}
